import { render, staticRenderFns } from "./SharedLink.vue?vue&type=template&id=3f35a7fb&"
import script from "./SharedLink.vue?vue&type=script&lang=js&"
export * from "./SharedLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports